import { render, staticRenderFns } from "./OrdersBell.vue?vue&type=template&id=e0cf7402&scoped=true"
import script from "./OrdersBell.vue?vue&type=script&lang=js"
export * from "./OrdersBell.vue?vue&type=script&lang=js"
import style0 from "./OrdersBell.vue?vue&type=style&index=0&id=e0cf7402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cf7402",
  null
  
)

export default component.exports